<template>
  <v-app>
    <v-main>
      <c-container form wide>
        <h1>Debug launch page</h1>

        <ul>
          <li v-for="item in orgs" :key="item.path">
            <router-link :to="{path: item.path}">{{item.name}}</router-link>
          </li>
        </ul>
      </c-container>
    </v-main>
  </v-app>
</template>

<script>
import CContainer from '@/components/CContainer'

export default {
  name: 'Launch',
  components: {
    CContainer
  },
  data: () => ({
    orgs: [
      { path: '/gadu', name: 'Gadu Rent' },
      { path: '/netzfukuoka', name: 'ネッツ福岡' },
      { path: '/carmel-yama', name: 'ヤマ自動車' }
    ]
  })
}
</script>
